module.exports = __webpack_public_path__ + "images/sol_cube_phone-b72aa7c7f3732f5cd19dd105da1f58fd.png";